var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[ {'active': _vm.getMenuState } ],attrs:{"id":"aside"}},[_c('div',{staticClass:"aside-inner"},[_c('fleet-overview'),_c('fleet-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }